<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 font-weight-medium']">{{header1}}</span>
      <span :class="['headline indigo--text text--darken-2 ml-2']">invoice</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 450px;">
      <v-row dense class="mt-3">
        <v-col cols="4">
          <AADate
            align="center"
            label="Invoice Date"
            :date="item.date"
            v-on:date-changed="item.date = $event"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            class="align-right-input"
            hide-details
            type="number"
            label="Amount"
            v-model="item.amount"
          ></v-text-field>
        </v-col>
        <v-col cols="5">
          <AADate
            solo
            align="center"
            clearable
            label="Paid Date"
            :date="item.datePaid"
            v-on:date-changed="item.datePaid = $event"
          />
        </v-col>
        <v-col cols="12">
          <v-radio-group v-model="rad" column>
            <v-radio value="workitem" class="mt-3">
              <v-select
                class="mt-n3"
                slot="label"
                :items="workItems"
                item-text="name"
                item-value="wiid"
                v-model="item.wiid"
                menu-props="auto"
                label="Select Work-item / Stage"
                hide-details
              ></v-select>
            </v-radio>
            <v-radio value="description" class="mt-5">
              <v-text-field
                class="mt-n3"
                slot="label"
                hide-details
                label="Description"
                v-model="item.description"
              ></v-text-field>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <v-textarea clearable hide-details label="Note" v-model="item.note"></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="!inNewMode" color="red darken-1" text @click="obj.remove(obj.item)">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="accept">Save</v-btn>
      <v-btn color="green darken-1" text @click="obj.close()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";
import AADate from "@/components/AADate";
import { getFormattedValue } from "@/shared.js";

export default {
  components: { AADate },
  props: {
    obj: Object
  },
  name: "DialogProjectInvoiceItem",
  data() {
    return {};
  },
  watch: {},
  computed: {
    item() {
      return this.obj.item;
    },
    rad: {
      get() {
        if (!this.item.hasOwnProperty("rad"))
          Vue.set(
            this.item,
            "rad",
            this.item.wiid ? "workitem" : "description"
          );
        return this.item.rad;
      },
      set(newValue) {
        this.item.rad = newValue;
        if (newValue == "workitem") this.item.description = "";
        else this.item.wiid = "";
      }
    },
    inNewMode() {
      return this.obj.inNewMode;
    },
    header1() {
      if (this.inNewMode) return "New";
      return "Edit";
    },
    workItems() {
      let xx = this.$store.getters.selectedProjectWorkItems;
      return xx;
    }
  },
  methods: {
    accept() {
      // remove the helper checked prop
      delete this.obj.item.isChecked;

      // call back
      this.obj.update(this.obj.item);
    }
  },
  updated() {
    //console.log("updated " + this.item.wiid);
  }
};
</script>

<style >
.align-right-input input {
  text-align: right;
}
.align-center-input input {
  text-align: center;
}
</style>
